import { useGameStore } from '@/store/gameStore';
export function LobbyScreen() {
  const startGame = useGameStore((s) => s.startGame);
  const highScore = useGameStore((s) => s.highScore);
  const setScreen = useGameStore((s) => s.setScreen);
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-slate-950 select-none">
      <div className="flex flex-col items-center gap-6 px-6 text-center">
        <div className="flex flex-col items-center gap-1">
          <h1 className="text-5xl font-black tracking-tight text-cyan-400 drop-shadow-[0_0_20px_rgba(0,212,255,0.6)]">
            LANE BLAZER
          </h1>
          <p className="text-slate-400 text-sm tracking-widest uppercase">Endless Racing</p>
        </div>
        <div className="w-full max-w-[280px] h-px bg-gradient-to-r from-transparent via-cyan-500 to-transparent" />
        {highScore > 0 && (
          <div className="flex flex-col items-center gap-1">
            <p className="text-xs text-slate-500 uppercase tracking-widest">Best Score</p>
            <p className="text-3xl font-bold text-yellow-400">{highScore}</p>
          </div>
        )}
        <div className="flex flex-col items-center gap-2 text-slate-400 text-sm">
          <p>Dodge oncoming traffic</p>
          <div className="flex gap-4 text-xs text-slate-500">
            <span>← → Arrow keys</span>
            <span>or Swipe</span>
          </div>
        </div>
        <div className="flex flex-col gap-3 w-full max-w-[240px]">
          <button
            onClick={startGame}
            className="px-10 py-4 bg-cyan-500 hover:bg-cyan-400 active:scale-95 text-slate-950 font-black text-lg rounded-xl transition-all duration-150 shadow-[0_0_30px_rgba(0,212,255,0.4)]"
          >
            PLAY
          </button>
          <button
            onClick={() => setScreen('howtoplay')}
            className="px-8 py-3 bg-slate-800 hover:bg-slate-700 active:scale-95 text-slate-300 font-bold text-sm rounded-xl transition-all duration-150"
          >
            How To Play
          </button>
        </div>
      </div>
    </div>
  );
}